import api from '../services/api';
import { TOKEN_LEGAL365, TASK_V2_GETTRIBUNALES, TASK_V2_GET_CASES_CREATE_INFO } from '../config.js'
import axios from 'axios'
import Cookies from 'universal-cookie'
import { act } from 'react';
import { Exposure } from 'react-bootstrap-icons';
// reducers/tabReducer.js
const data = {
    paises: [],
    regiones: [],
    generos: [],
    estadoCivil: [],
    comunas: [],
    provincias: [],
    negocios: [],
    tribunales: [],
    grupos: [],
    tribunalesext: [],
    sucursales: [],
    seriviciosLN: [],
    acreedores: [],
    metodosPago: [],
    templateContratos: []
};

export default function generalReducer(state = data, action) {
    switch (action.type) {
        case 'SET_PAISES':
            return { ...state, paises: action.payload }
        case 'SET_REGIONES':
            return { ...state, regiones: action.payload }
        case 'SET_GENERO':
            return { ...state, generos: action.payload }
        case 'SET_ESTADO_CIVIL':
            return { ...state, estadoCivil: action.payload }
        case 'SET_COMUNAS':
            return { ...state, comunas: action.payload }
        case 'SET_PROVINCIAS': // Agregar el caso para SET_PROVINCIAS
            return { ...state, provincias: action.payload }
        case 'SET_NEGOCIOS':
            return { ...state, negocios: action.payload }
        case 'SET_TRIBUNALES':
            return { ...state, tribunales: action.payload }
        case 'SET_GRUPOS':
            return { ...state, grupos: action.payload }
        case 'SET_TRIBUNALES_EXT':
            return { ...state, tribunalesext: action.payload }
        case 'SET_SUCURSALES':
            return { ...state, sucursales: action.payload }
        case 'SERVICIOS_LINEA_NEGOCIO':
            return { ...state, seriviciosLN: action.payload }
        case 'ACREEDORES':
            return { ...state, acreedores: action.payload }
        case 'SET_METODOS_PAGO':
            return { ...state, metodosPago: action.payload }
        case 'SET_TEMPLATE_CONTRATOS':
            return { ...state, templateContratos: action.payload }
        default:
            return state;
    }
};

export const setFetch = (type, URL) => async (dispatch) => {

    const cookies = new Cookies()
    try {
        //const RES = await axios.get(TASK_V2_GETINFO)
        const RES = await api.get(URL, { headers: { 'Authorization': `Bearer ${cookies.get('tokenGcc')}` } });
        if (RES.status === 200)
            dispatch({ type, payload: RES.data })
    } catch (error) {
        console.error(`Error en ${type}`, error)
    }
}

export const setCargaDatos = (option) => async (dispatch, getState) => {
    const _gen = getState().general;
    console.log(_gen)
    if (_gen.paises.length === 0 || option == "paises")
        await dispatch(setFetch('SET_PAISES', '/Country'))
    if (_gen.regiones.length === 0 || option == "regiones")
        await dispatch(setFetch('SET_REGIONES', '/Regions'))
    if (_gen.generos.length === 0 || option == "generos")
        await dispatch(setFetch('SET_GENERO', '/Genere'))
    if (_gen.estadoCivil.length === 0 || option == "estadoCivil")
        await dispatch(setFetch('SET_ESTADO_CIVIL', '/EstadoCivil'))
    if (_gen.comunas.length === 0 || option == "comunas") // Agregar la lógica para cargar comunas
        await dispatch(setFetch('SET_COMUNAS', '/Districts'))
    if (_gen.provincias.length === 0 || option == "provincias") // Agregar la lógica para cargar provincias
        await dispatch(setFetch('SET_PROVINCIAS', '/Province'))
    if (_gen.negocios.length === 0 || option == "negocios") // Agregar la lógica para cargar lineas de negocio
        await dispatch(setFetch('SET_NEGOCIOS', '/LineOfBusiness'))
    if (_gen.tribunales.length === 0 || option == "tribunales") // Agregar la lógica para cargar lineas de negocio
        await dispatch(GetTribunales('SET_TRIBUNALES', TASK_V2_GETTRIBUNALES))
    if (_gen.grupos.length === 0 || option == "grupos") // Agregar la lógica para cargar lineas de negocio
        await dispatch(GetGrupos('SET_GRUPOS', TASK_V2_GET_CASES_CREATE_INFO))
    if (_gen.tribunalesext.length === 0 || option == "tribunalesext") // Agregar la lógica para cargar lineas de negocio
        await dispatch(GetTribunalesExt('SET_TRIBUNALES_EXT', TASK_V2_GET_CASES_CREATE_INFO))
    if (_gen.sucursales.length === 0 || option == "scursales") // Agregar la lógica para cargar lineas de negocio
        await dispatch(setFetch('SET_SUCURSALES', '/Branch'))
    if (_gen.metodosPago.length === 0 || option == "metodosPago") // Agregar la lógica para cargar lineas de negocio
        await dispatch(setFetch('SET_METODOS_PAGO', '/MetodoPago'))
    return true;
}

export const setCargaGeneral = (option) => async (dispatch, getState) => {
    if (option == "paises")
        await dispatch(setFetch('SET_PAISES', '/Country'))
    if (option == "regiones")
        await dispatch(setFetch('SET_REGIONES', '/Regions'))
    if (option == "generos")
        await dispatch(setFetch('SET_GENERO', '/Genere'))
    if (option == "estadoCivil")
        await dispatch(setFetch('SET_ESTADO_CIVIL', '/EstadoCivil'))
    if (option == "comunas") // Agregar la lógica para cargar comunas
        await dispatch(setFetch('SET_COMUNAS', '/Districts'))
    if (option == "provincias") // Agregar la lógica para cargar provincias
        await dispatch(setFetch('SET_PROVINCIAS', '/Province'))
    if (option == "negocios") // Agregar la lógica para cargar lineas de negocio
        await dispatch(setFetch('SET_NEGOCIOS', '/LineOfBusiness'))
    if (option == "tribunales") // Agregar la lógica para cargar lineas de negocio
        await dispatch(GetTribunales('SET_TRIBUNALES', TASK_V2_GETTRIBUNALES))
    if (option == "grupos") // Agregar la lógica para cargar lineas de negocio
        await dispatch(GetGrupos('SET_GRUPOS', TASK_V2_GET_CASES_CREATE_INFO))
    if (option == "tribunalesext") // Agregar la lógica para cargar lineas de negocio
        await dispatch(GetTribunalesExt('SET_TRIBUNALES_EXT', TASK_V2_GET_CASES_CREATE_INFO))
    if (option == "sucursales") // Agregar la lógica para cargar lineas de negocio
        await dispatch(setFetch('SET_SUCURSALES', '/Branch'))
    if (option == "metodosPago") // Agregar la lógica para cargar lineas de negocio
        await dispatch(setFetch('SET_METODOS_PAGO', '/MetodoPago'))
    return true;
}



export const getTemplateContratos = (LineaNegocio) => async (dispatch, getState) => {
    await dispatch(setFetch('SET_TEMPLATE_CONTRATOS', '/Layouts/V2/' + LineaNegocio))
    return true;
}



export const getServiciosLineaNegocio = (contractId) => async (dispatch, getState) => {
    await dispatch(setFetch('SERVICIOS_LINEA_NEGOCIO', '/Servicio/V2/contractId/' + contractId))
}

export const getAcreedores = (contractId) => async (dispatch, getState) => {
    await dispatch(setFetch('ACREEDORES', '/Acreedores/V2/AcreedoresSistema/'))
}


export const GetTribunales = (type, URL) => async (dispatch, getState) => {

    try {
        //const RES = await axios.get(TASK_V2_GETINFO)
        const RES = await axios.get(URL, { headers: { 'Authorization': `Bearer ` + TOKEN_LEGAL365 } })
        if (RES.status === 200) {
            dispatch({ type: 'SET_TRIBUNALES', payload: RES.data })
        }
    } catch (error) {
        console.error(`Error en ${type}`, error)
    }
}

export const GetGrupos = (type, URL) => async (dispatch, getState) => {

    try {
        //const RES = await axios.get(TASK_V2_GETINFO)
        const RES = await axios.get(URL, { headers: { 'Authorization': `Bearer ` + TOKEN_LEGAL365 } })
        if (RES.status === 200) {
            dispatch({ type: 'SET_GRUPOS', payload: RES.data.groups })
        }
    } catch (error) {
        console.error(`Error en ${type}`, error)
    }
}

export const GetTribunalesExt = (type, URL) => async (dispatch, getState) => {

    try {
        //const RES = await axios.get(TASK_V2_GETINFO)
        const RES = await axios.get(URL, { headers: { 'Authorization': `Bearer ` + TOKEN_LEGAL365 } })
        if (RES.status === 200) {
            dispatch({ type: 'SET_TRIBUNALES_EXT', payload: RES.data.tribunales })
        }
    } catch (error) {
        console.error(`Error en ${type}`, error)
    }
}